import { styled, Typography } from '@material-ui/core';
import { FC } from 'react';

import { Space } from '../../../cnusr/components/util/constants';
import { Button } from '../../ui';
import { WelcomeMessage } from '../components/welcomeMessage';

const Container = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(1.75),
}));

const Fields = styled('div')(({ theme }) => ({
  width: theme.spacing(33.5),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  '& > div': {
    marginBottom: theme.spacing(0.75),
  },
}));

interface Props {
  onRegister: () => void;
  onLogin: () => void;
}

export const GetStarted: FC<Props> = ({ onRegister, onLogin }) => {
  return (
    <Container id="getStarted">
      <WelcomeMessage />
      <Fields>
        <Typography variant="h6" align="center" color="textSecondary">
          Already have an account?
        </Typography>
        <Button color="primary" fullWidth variant="contained" onClick={onLogin}>
          Join Class
        </Button>
        <Space />
        <Typography variant="h6" align="center" color="textSecondary">
          Need to create an account?
        </Typography>
        <Button
          color="primary"
          fullWidth
          variant="contained"
          onClick={onRegister}
        >
          Sign Up
        </Button>
      </Fields>
    </Container>
  );
};
